import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CCol,
    CRow,
} from '@coreui/react';
import { ThePermission } from '../ThePermission';
import { userActions, storeActions, employeeActions, vendorActions, projectActions, itemActions, assetActions } from 'src/_actions';
import { helps } from 'src/_helpers';
import configs from 'src/appConfigs';
import PUT from 'src/views/assets/PUT';

class PUTContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page_header: 'Hủy / Lưu Kho',
            categoty_id: 'QTT',
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        let category_id = this.props.match.params.category_id;
        let category = helps.getItemFromArr(configs.asset_categories, category_id);
        this.setState({ page_header: category.label + ": " + this.state.page_header, categoty_id: category_id });
        if (!this.props.users) {
            this.props.getUsers();
        }

        this.getEmployees();
        this.getStores();
        this.getVendors();
        this.getItems();
        this.getProjects();
    }

    async getEmployees() {
        if (helps.isEmpty(this.props.employees)) {
            await this.props.getEmployees();
        }
    }

    async getStores() {
        if (helps.isEmpty(this.props.stores)) {
            await this.props.getStores();
        }
    }

    async getVendors() {
        if (helps.isEmpty(this.props.vendors)) {
            await this.props.getVendors();
        }
    }

    async getItems() {
        if (helps.isEmpty(this.props.items)) {
            await this.props.getItems();
        }
    }

    async getProjects() {
        if (helps.isEmpty(this.props.projects)) {
            await this.props.getProjects();
        }
    }

    handleSubmit(record) {
        const { items, stores } = this.props;
        let category_id = this.props.match.params.category_id;
        var url = '/assets/' + category_id;
        let asset = {
            asset_date: record.asset_date,
            create_by: this.props.user.id,
            create_date: new Date(),
            from_to: record.from_to,
            state: record.state,
            store_id: record.store_id,
            project_id: record.project_id,
            employee_id: record.employee_id,
            vendor_id: record.vendor_id,
            category_id: record.category_id,
        }
        if (helps.isEmpty(record.id)) {
            if (!helps.isEmpty(record.selected_items) && record.selected_items.length > 0) {
                let asset_items = [];
                record.selected_items.map((selected_item) => {
                    let asset_item = {
                        create_by: this.props.user.id,
                        create_date: new Date(),
                        item_id: selected_item.item_id,
                        dimension: selected_item.dimension,
                        quantity: selected_item.quantity,
                    }
                    let item = helps.getItemFromArr(items, selected_item.item_id);
                    if (helps.isEmpty(item.inventory)) {
                        item['inventory'] = [];
                        asset_item['pre'] = 0;
                        asset_item['inventory'] = asset_item['pre'] - parseInt(asset_item.quantity);
                        item['inventory'] = {
                            store_id: asset.store_id,
                            current_inventory: asset_item.inventory,
                        };
                    } else {
                        let found_index = item.inventory.findIndex(_inventory => _inventory.store_id === asset.store_id);
                        let item_store = helps.getItemFromArr(item.inventory, asset.store_id, 'store_id');
                        if (found_index < 0) {
                            asset_item['pre'] = 0;
                            asset_item['inventory'] = asset_item['pre'] - parseInt(asset_item.quantity);
                            item['inventory'].push({
                                store_id: asset.store_id,
                                current_inventory: asset_item.inventory,
                            });
                        } else {
                            let updated_inventory = parseInt(item_store.current_inventory) - parseInt(asset_item.quantity);
                            item.inventory[found_index] = { store_id: asset.store_id, current_inventory: updated_inventory };
                            asset_item['pre'] = parseInt(item_store.current_inventory);
                            asset_item['inventory'] = updated_inventory;
                        }
                    }
                    item['inventory'] = helps.unigByKeepLast(item.inventory, it => it.store_id);
                    //console.log(item.inventory, helps.isEmpty(item.inventory))
                    this.props.updateItemField(item, 'inventory');
                    asset_items.push(asset_item);

                });
                asset['asset_items'] = asset_items;
                this.props.addAsset(asset);
            }
        } else {
            this.props.update(record);
        }
        //this.props.history.push(url);
    }

    render() {

        return (
            <ThePermission {... this.props} component="assets" action="edit">
                <CRow key={helps.convertToSlug(this.state.page_header)}>
                    <CCol xl={12}>
                        <CCard>
                            <CCardHeader>
                                <CRow>
                                    <CCol md={4} sm={12}>
                                        <h1 className='mb-1'>{this.state.page_header}</h1>
                                    </CCol>
                                </CRow>
                            </CCardHeader>
                            <CCardBody>
                                <PUT {... this.props} handleSubmit={this.handleSubmit} category_id={this.state.categoty_id} />
                            </CCardBody >
                        </CCard >
                    </CCol >
                </CRow >
            </ThePermission>

        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users } = state.userReducer;
    const { vendors } = state.vendorReducer;
    const { stores } = state.storeReducer;
    const { employees } = state.employeeReducer;
    const { projects } = state.projectReducer;
    const { items } = state.itemReducer;
    return { user, users, vendors, stores, employees, projects, items };
}

const actionCreators = {
    addAsset: assetActions.add,
    getUsers: userActions.getAll,
    getEmployees: employeeActions.getAll,
    getVendors: vendorActions.getAll,
    getStores: storeActions.getAll,
    getProjects: projectActions.getAll,
    getItems: itemActions.getAll,
    updateItemField: itemActions.updateField,
};

const connectedContainer = connect(mapStateToProps, actionCreators)(PUTContainer);
export { connectedContainer as PUTContainer };